var _rect, _path, _path2, _path3, _path4, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBusinessTransferPrice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.708 5.40043C11.7559 5.40043 9.8838 6.19081 8.50346 7.5977C7.12312 9.00458 6.34766 10.9127 6.34766 12.9024C6.34766 14.892 7.12312 16.8001 8.50346 18.207C9.8838 19.6139 11.7559 20.4043 13.708 20.4043L13.708 12.9024L13.708 5.40043Z",
    fill: "#646174"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2959 30.5488C24.248 30.5488 26.1201 29.7584 27.5004 28.3515C28.8808 26.9446 29.6562 25.0365 29.6562 23.0469C29.6562 21.0572 28.8808 19.1491 27.5004 17.7422C26.1201 16.3353 24.248 15.5449 22.2959 15.5449L22.2959 23.0469L22.2959 30.5488Z",
    fill: "#646174"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5976 13.7041C30.5976 11.752 29.8072 9.8799 28.4004 8.49956C26.9935 7.11922 25.0853 6.34375 23.0957 6.34375C21.106 6.34375 19.1979 7.11922 17.791 8.49956C16.3841 9.8799 15.5938 11.752 15.5938 13.7041L23.0957 13.7041L30.5976 13.7041Z",
    fill: "#646174"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44926 22.292C5.44926 24.2441 6.23964 26.1162 7.64652 27.4965C9.05341 28.8769 10.9616 29.6523 12.9512 29.6523C14.9408 29.6523 16.849 28.8769 18.2559 27.4965C19.6627 26.1162 20.4531 24.2441 20.4531 22.292L12.9512 22.292L5.44926 22.292Z",
    fill: "#646174"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 34.4,
    height: 34.4,
    rx: 5,
    stroke: "#B7B7B7",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTransferPrice);
export default __webpack_public_path__ + "static/media/BusinessTransferPrice.c556666ff6200bc0c46557f5f926d0b3.svg";
export { ForwardRef as ReactComponent };